import { createReducer } from '@common/utils/redux';
import { ORDERS_ACTION_TYPES } from '../const/orders';

const initialState = {
  list: [],
  ordersTotalCount: 0
};

export default createReducer(
  initialState,
  {
    [ORDERS_ACTION_TYPES.setList]: (state, list) => ({
      ...state,
      list,
    }),
    [ORDERS_ACTION_TYPES.setListCount]: (state, ordersTotalCount) => ({
      ...state,
      ordersTotalCount,
    }),
  }
);